import fetch from 'axios';

export const appendUserTrackEvent = ({
  type,
  userId,
  deviceId,
  region,
  platform,
  eventName,
  utmSource,
  utmMedium,
  utmCampaign,
  utmContent,
  url,
}) =>
  fetch('/appendUserTrackEvent', {
    method: 'POST',
    data: {
      type,
      userId,
      deviceId,
      region,
      platform,
      eventName,
      utmSource,
      utmMedium,
      utmCampaign,
      utmContent,
      url,
    },
  });

/**
 *
 * @param {Object[]} campaignResult
 * @param {number} campaignResult.userId
 * @param {string} campaignResult.campaignName
 * @param {string} campaignResult.qzId
 * @param {number} campaignResult.order
 * @param {number} campaignResult.answer
 * @param {number} campaignResult.correctAns
 */
export const appendCampaignResult = campaignResult =>
  fetch('/appendCampaignResult', {
    method: 'POST',
    data: {
      campaignResult,
    },
  });



// WEBPACK FOOTER //
// ./app/services/local.js